import React from 'react';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

export const CropPreview = props => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    marginBottom: '50px',
    }}
  >
    <div style={{ borderRadius: '6px', overflow: 'hidden' }}><CroppedImageView {...props} /></div>
  </div>
);
